import * as React from 'react';
import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';

import StringField from '../core/components/Fields/StringField.tsx';
import { fetchLookupOptions } from '../document/components/useLookup.tsx';
import LookupField from './LookupField.tsx';

export interface ClientSelection {
    customerNumber: string;
    companyName: string;
    entity: Record<string, unknown>;
}

interface ClientLookupInputProps {
    clientLookupDefinitionId: string | null;
    value: string;
    onValueChange: (value: string) => void;
    onClientSelect: (selection: ClientSelection) => void;
}

const ClientLookupInput = ({
    clientLookupDefinitionId,
    value,
    onValueChange,
    onClientSelect,
}: ClientLookupInputProps) => {
    const apolloClient = useApolloClient();

    const fetchClientOptions = useCallback(
        (searchTerm: string) =>
            fetchLookupOptions({
                client: apolloClient,
                lookupDefinitionId: clientLookupDefinitionId!,
                lookupFieldName: 'client_id1',
                partitionId: null,
                fetchPolicy: 'no-cache',
            })(searchTerm, 0, 10),
        [apolloClient, clientLookupDefinitionId]
    );

    if (!clientLookupDefinitionId) {
        return <StringField value={value} onValueChange={(v: any) => onValueChange(String(v ?? ''))} />;
    }

    return (
        <LookupField
            lookupFieldName="client_id1"
            lookupType="ClientLookupType"
            fetchOptions={fetchClientOptions}
            value={value}
            onValueChange={onValueChange}
            onSelect={(option) => {
                const customerNumber = String(option?.clientId1 ?? option?.value ?? '');
                const companyName = String(option?.companyName ?? option?.label ?? '');
                const { data: _d, value: _v, label: _l, ...entity } = (option || {}) as any;
                onClientSelect({ customerNumber, companyName, entity });
            }}
        />
    );
};

export default ClientLookupInput;
